// Shared media-type detection for stored media URLs (image / video / pdf / link).
export const IMAGE_EXTENSIONS = ["jpg", "jpeg", "png", "gif", "webp", "svg", "bmp", "avif"];
export const VIDEO_EXTENSIONS = ["mp4", "webm", "mov", "m4v", "ogv", "ogg"];

const getExtension = (url) => {
  try {
    return new URL(url).pathname.split(".").pop().toLowerCase();
  } catch {
    return "";
  }
};

// Returns "image" | "video" | "pdf" | "link"
export const getMediaType = (url) => {
  const ext = getExtension(url);
  if (IMAGE_EXTENSIONS.includes(ext)) return "image";
  if (VIDEO_EXTENSIONS.includes(ext)) return "video";
  if (ext === "pdf") return "pdf";
  return "link";
};

export const looksLikeImage = (url) => getMediaType(url) === "image";
